import { Video } from "./styles";

export default function VideoComponent(video) {
  const video_url = video.video + "?controls=0&modestbranding=1&rel=0&showinfo=0"
  const description = video.description

  return (
    (video_url && (<Video>
      <iframe src={video_url} frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>

      {description && (<div>
        <span>{description}</span>
      </div>)}
    </Video>))

  );
}
